export const dateRangePresets = [
  ['today', 'Today'],
  ['last7', 'Last 7 days'],
  ['last30', 'Last 30 days'],
  ['thisMonth', 'This month'],
  ['lastMonth', 'Last month'],
  ['last12Months', 'Last 12 months'],
  ['yearToDate', 'Year to date'],
];

// Construct calendar dates locally; UTC serialization can shift the selected day.
export function localDateString(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function presetDateRange(preset, now = new Date()) {
  if (preset === 'all') return { preset, start: null, end: null };
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const start = new Date(end);
  switch (preset) {
    case 'today': break;
    case 'last7': start.setDate(start.getDate() - 6); break;
    case 'last30': start.setDate(start.getDate() - 29); break;
    case 'thisMonth': start.setDate(1); break;
    case 'lastMonth':
      start.setDate(1);
      start.setMonth(start.getMonth() - 1);
      end.setDate(0);
      break;
    case 'last12Months': {
      const previousYear = end.getFullYear() - 1;
      const lastDay = new Date(previousYear, end.getMonth() + 1, 0).getDate();
      start.setFullYear(previousYear, end.getMonth(), Math.min(end.getDate(), lastDay));
      start.setDate(start.getDate() + 1);
      break;
    }
    case 'yearToDate': start.setMonth(0, 1); break;
    default: throw new Error('Unknown date range preset');
  }
  return { preset, start: localDateString(start), end: localDateString(end) };
}
